import React, {useContext} from "react";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {UserWhoMadeContentNodeSearchContext} from "./UserWhoMadeContentNodeSearchContainer";

export const UserWhoMadeContentNodeFilter = () => {
    const { filters, setFilters, clearFilters } = useContext(UserWhoMadeContentNodeSearchContext);

    return (
        <div className="flex mb-3 flex-wrap">
            <div>
                <InputText
                    className="m-1 w-21rem"
                    value={filters.filterByLastName || ""}
                    onChange={(e) =>
                        setFilters({
                            ...filters,
                            filterByLastName: e.target.value,
                        })
                    }
                    placeholder={"Nachname ...."}
                />
                <InputText
                    className="m-1 w-21rem"
                    value={filters.filterByFirstName || ""}
                    onChange={(e) =>
                        setFilters({
                            ...filters,
                            filterByFirstName: e.target.value,
                        })
                    }
                    placeholder={"Vorname ...."}
                />

            </div>
            <div className="flex align-items-center m-1">
                <Button
                    className=""
                    label={"Zurücksetzen"}
                    icon="pi pi-times"
                    onClick={() => {
                        clearFilters();
                    }}
                />
            </div>
        </div>
    );
};
